import styled from 'styled-components'

export const PriceRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: baseline;
  margin-top: 1.8rem;
  flex-wrap: wrap;
  justify-content: start;
`
